// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__2BrzD","footer":"ModalCreateQualiphyProcedure_footer__3LAmC","additionData":"ModalCreateQualiphyProcedure_additionData__3tM-k"};